import { Link, Navigate, Outlet, useLocation } from 'react-router-dom';
import { Archive, Gift, LifeBuoy, Mail, Package, Users } from 'lucide-react';
import { SectionHeading } from '../components/ui';
import { c } from '../styles/theme';
import { paths } from './paths';

const TABS = [
  { to: paths.adminSupport, label: 'Support', icon: LifeBuoy },
  { to: paths.adminUsers, label: 'Users', icon: Users },
  { to: paths.adminArchive, label: 'Archive', icon: Archive },
  { to: paths.adminMail, label: 'Mail', icon: Mail },
  { to: paths.adminBonuses, label: 'Bonuses', icon: Gift },
  { to: paths.adminVault, label: 'Vault', icon: Package },
] as const;

export default function Admin() {
  const location = useLocation();
  if (location.pathname === paths.admin) {
    return <Navigate to={paths.adminSupport} replace />;
  }

  return (
    <div>
      <SectionHeading
        as="h1"
        title="Admin"
        subtitle="Manage users, support, mail, deletion archives, bonuses and the vault"
        marginBottom={16}
      />

      <div
        style={{
          display: 'flex',
          gap: 8,
          flexWrap: 'wrap',
          marginBottom: 18,
        }}
      >
        {TABS.map((tab) => {
          const active = location.pathname === tab.to;
          const Icon = tab.icon;
          return (
            <Link
              key={tab.to}
              to={tab.to}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                padding: '8px 12px',
                borderRadius: 999,
                border: active ? `1px solid ${c.accentBorder}` : `1px solid ${c.border}`,
                background: active ? c.accentSoft : c.surface1,
                color: active ? c.accent : c.text2,
                textDecoration: 'none',
                fontSize: 12,
                fontWeight: 500,
              }}
            >
              <Icon size={13} />
              {tab.label}
            </Link>
          );
        })}
      </div>

      <Outlet />
    </div>
  );
}
